<template>
  <StyledText ref="targetEl" :fontId="fontId" tag="p" :class="[testClassName]">
    <span :class="truncateClass ? classes.truncate : ''">
      {{ overideText || text }}
    </span>
  </StyledText>
</template>

<script lang="ts">
import StyledText from "./styled/Text.vue";
import { defineComponent, computed, PropType } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import {
  injectAdTag,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";
import { AdFormInput, Brand, AdFormInputTypes } from "@fresh8/types/src/index";
import { createUseStyles } from "@fresh8/vue-jss/src";

const useStyles = createUseStyles({
  truncate: {
    display: "-webkit-box",
    "-webkit-line-clamp": props => props.truncateSize,
    "-webkit-box-orient": "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: 1.2
  }
});

export default defineComponent({
  name: "Text",
  components: {
    StyledText
  },
  props: {
    styleGroup: {
      type: String,
      required: true
    },
    truncate: {
      type: Number,
      required: false,
      default: 0
    },
    overideText: {
      type: String,
      required: false,
      default: undefined
    },
    get: {
      type: Function as PropType<
        (brand: Brand) => { value: string; font: string }
      >,
      required: true
    },
    enableTextEditing: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  setup(props) {
    const { brand } = injectBrand();
    const fontId = computed(() => props.get(brand.value).font);
    const { operator } = injectAdTag();

    const targetArr = computed((): AdFormInput<AdFormInputTypes>[] =>
      props.enableTextEditing
        ? [
            {
              type: "text",
              get: () => props.get(brand.value).value,
              set: (value: string) => (props.get(brand.value).value = value)
            },
            {
              type: "font",
              get: () => props.get(brand.value).font,
              set: (value: string) => (props.get(brand.value).font = value)
            }
          ]
        : [
            {
              type: "font",
              get: () => props.get(brand.value).font,
              set: (value: string) => (props.get(brand.value).font = value)
            }
          ]
    );

    const { targetEl } = composePopoverForm(props.styleGroup, targetArr.value);

    const reactiveStyles = computed(() => ({
      truncateSize: props.truncate
    }));
    const classes = useStyles(reactiveStyles);

    return {
      targetEl,
      fontId,
      classes,
      truncateClass: computed(() => !!props.truncate),
      text: computed(() =>
        props.get(brand.value).value.replace("%operator%", operator.value.name)
      ),
      testClassName: computed(
        () =>
          "text-style-" +
          props.styleGroup
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
